module.exports = __webpack_public_path__ + "img/content-loader.457e30b7.svg";